import  Provincia  from "./provincia";
import Entity from '../entity'

export default class Municipio extends Entity<number> {
    nombre: string;
    provinciaId: number;
    provincia: Provincia;
}